module.exports = __webpack_public_path__ + "static/media/ic-listview-white.5590a66b.svg";